module.exports = __webpack_public_path__ + "img/all-1.238816c3.png";